export default __webpack_public_path__ + "static/media/KI.f44f8ace.svg";